"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = require("js-cookie");
document.addEventListener('alpine:init', function () {
    Alpine.data('geoStateSelector', function (config) {
        return {
            cookieName: "geo-".concat(config.uniqueID),
            visible: false,
            stage: 0,
            config: config,
            previouslyFocused: null,
            init: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var params, hasQueryParam, controller_1, timeoutId, response, geo, _a, prefersReducedMotion;
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                params = new URLSearchParams(window.location.search);
                                hasQueryParam = config.queryParam && params.has(config.queryParam);
                                // Mark-as-local mode: silently set cookie and exit.
                                if (config.markAsLocal) {
                                    if (!Cookies.get(this.cookieName)) {
                                        this.setCookie();
                                    }
                                    return [2 /*return*/];
                                }
                                // Query param present: set cookie, track bypass, don't show.
                                if (hasQueryParam) {
                                    this.setCookie();
                                    this.$store.app.track({
                                        event: 'geo_state_selector_bypass',
                                        type: 'query_param',
                                        module: 'geo-state-selector',
                                        data: { param: config.queryParam },
                                    });
                                    return [2 /*return*/];
                                }
                                // Returning visitor: cookie exists, don't show.
                                if (Cookies.get(this.cookieName)) {
                                    return [2 /*return*/];
                                }
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 4, , 5]);
                                controller_1 = new AbortController();
                                timeoutId = setTimeout(function () { return controller_1.abort(); }, 10000);
                                return [4 /*yield*/, fetch('/wp-json/rest/v1/geolocation', {
                                        signal: controller_1.signal,
                                    })];
                            case 2:
                                response = _b.sent();
                                clearTimeout(timeoutId);
                                return [4 /*yield*/, response.json()];
                            case 3:
                                geo = _b.sent();
                                if (geo.state === 'VIC') {
                                    this.setCookie('vic');
                                    this.$store.app.track({
                                        event: 'geo_state_selector_auto_local',
                                        type: 'auto_detect',
                                        module: 'geo-state-selector',
                                        data: { country: geo.country, state: geo.state },
                                    });
                                    return [2 /*return*/];
                                }
                                return [3 /*break*/, 5];
                            case 4:
                                _a = _b.sent();
                                return [3 /*break*/, 5];
                            case 5:
                                // First-time visitor on a target page: show overlay.
                                this.previouslyFocused = document.activeElement;
                                prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                                setTimeout(function () {
                                    _this.visible = true;
                                    _this.lockScroll(true);
                                    _this.setInert(true);
                                    if (prefersReducedMotion) {
                                        // Skip animation — show everything immediately.
                                        _this.stage = 3;
                                        _this.$nextTick(function () {
                                            _this.$el.focus();
                                        });
                                    }
                                    else {
                                        // Stage 1: background image fades in from black.
                                        setTimeout(function () {
                                            _this.stage = 1;
                                        }, 100);
                                        // Stage 2: text content appears.
                                        setTimeout(function () {
                                            _this.stage = 2;
                                        }, 1000);
                                        // Stage 3: buttons appear, then move focus into the dialog.
                                        setTimeout(function () {
                                            _this.stage = 3;
                                            setTimeout(function () {
                                                _this.$el.focus();
                                            }, 700);
                                        }, 1600);
                                    }
                                }, 300);
                                /* TODO: validate this tracking */
                                this.$store.app.track({
                                    event: 'geo_state_selector_shown',
                                    type: 'impression',
                                    module: 'geo-state-selector',
                                    data: {},
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
            selectState: function (label, url) {
                this.$store.app.track({
                    event: 'geo_state_selector_click',
                    type: 'click',
                    module: 'geo-state-selector',
                    data: {
                        state: label,
                        url: url || 'local',
                    },
                });
                this.setCookie();
                if (url) {
                    // External state: redirect with query param appended.
                    var separator = url.includes('?') ? '&' : '?';
                    window.location.href = url + separator + config.queryParam;
                }
                else {
                    // Local state: close overlay, stay on site.
                    this.close();
                }
            },
            close: function () {
                this.visible = false;
                this.lockScroll(false);
                this.setInert(false);
                // Restore focus.
                if (this.previouslyFocused) {
                    this.previouslyFocused.focus();
                }
            },
            setCookie: function (value) {
                if (value === void 0) { value = '1'; }
                Cookies.set(this.cookieName, value, {
                    expires: 30,
                });
            },
            lockScroll: function (lock) {
                document.body.classList.toggle('fixed', lock);
                document.body.classList.toggle('overflow-y-scroll', lock);
                document.body.classList.toggle('w-full', lock);
            },
            setInert: function (inert) {
                var page = document.getElementById('page');
                if (page) {
                    if (inert) {
                        page.setAttribute('inert', '');
                    }
                    else {
                        page.removeAttribute('inert');
                    }
                }
            },
            trapFocus: function (event) {
                var focusableElements = this.$el.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusableElements.length === 0)
                    return;
                var firstEl = focusableElements[0];
                var lastEl = focusableElements[focusableElements.length - 1];
                if (event.shiftKey && document.activeElement === firstEl) {
                    event.preventDefault();
                    lastEl.focus();
                }
                else if (!event.shiftKey && document.activeElement === lastEl) {
                    event.preventDefault();
                    firstEl.focus();
                }
            },
        };
    });
});
